<!-- Blocking Processing Overlay -->
<div *ngIf="isProcessingBatch" class="processing-overlay">
  <div class="processing-modal">
    <div class="processing-content">
      <mat-spinner diameter="48" color="primary"></mat-spinner>

      <div class="processing-info">
        <h3 class="processing-title">Actualizando Proveedores</h3>

        <div *ngIf="activeProcessingServiceName" class="current-service">
          <p class="service-text">
            Procesando: <strong>{{ activeProcessingServiceName }}</strong>
          </p>
        </div>

        <div class="progress-section">
          <p class="progress-counter">
            {{ completedServicesCount }} de {{ totalServicesCount }} servicios
            completados
          </p>

          <mat-progress-bar
            mode="determinate"
            [value]="
              totalServicesCount > 0
                ? (completedServicesCount / totalServicesCount) * 100
                : 0
            "
            class="progress-bar"
          >
          </mat-progress-bar>

          <p class="progress-percentage">
            {{
              totalServicesCount > 0
                ? ((completedServicesCount / totalServicesCount) * 100).toFixed(
                    0
                  )
                : 0
            }}%
          </p>
        </div>

        <p class="processing-message">
          Por favor espere, no cierre esta ventana...
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Modal Dialog Content -->
<div *ngIf="!isProcessingBatch" class="modal-container">
  <!-- Header Row -->
  <div class="modal-header-row">
    <div class="header-title-box">
      <div class="icon-shell">
        <i-tabler name="building-store" class="header-icon"></i-tabler>
      </div>
      <div class="header-text-group">
        <span class="eyebrow-text">CATÁLOGO DE PROVEEDORES</span>
        <h3
          class="modal-title"
          [matTooltip]="dialogData?.modalTitle || 'Seleccionar Proveedor'"
        >
          {{ dialogData?.modalTitle || "Seleccionar Proveedor" }}
        </h3>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="close-button"
      (click)="handleCancelClick()"
      matTooltip="Cerrar modal"
    >
      <i-tabler name="x"></i-tabler>
    </button>
  </div>

  <h5
    *ngIf="
      !isLoadingCatalog &&
      !isProvidersListEmpty &&
      providerList.length > 0 &&
      dialogData?.filtered?.length &&
      dialogData.filtered.length > 1
    "
    class="info-text"
  >
    * Se están listando los proveedores que ofrecen todos los servicios
    seleccionados en común.
  </h5>

  <div class="modal-content">
    <p
      *ngIf="!isLoadingCatalog && providersCatalogMessage"
      class="providers-status-message"
    >
      {{ providersCatalogMessage }}
    </p>

    <!-- Search Form Field with Autocomplete -->
    <mat-form-field
      appearance="outline"
      *ngIf="!isLoadingCatalog && !isProvidersListEmpty"
      class="search-field"
    >
      <mat-label>Buscar Proveedor</mat-label>
      <input
        type="text"
        matInput
        [formControl]="providerSearchControl"
        [matAutocomplete]="autoProvider"
        placeholder="Escriba el nombre del proveedor..."
      />
      <mat-autocomplete
        #autoProvider="matAutocomplete"
        [displayWith]="getOptionDisplayLabel"
      >
        <mat-option
          *ngFor="let providerOption of filteredProviderOptions$ | async"
          [value]="providerOption"
          class="provider-option-item"
        >
          <div class="option-content">
            <span class="provider-name">{{ providerOption.nombre }}</span>
            <span
              *ngIf="providerOption.tipoProveedor"
              class="provider-type-pill"
            >
              {{ providerOption.tipoProveedor }}
            </span>
          </div>
        </mat-option>
        <mat-option *ngIf="providerList.length === 0" disabled>
          {{ providersCatalogMessage || "No hay proveedores disponibles" }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Empty State -->
    <div
      *ngIf="!isLoadingCatalog && isProvidersListEmpty"
      class="providers-empty-state"
    >
      <i-tabler name="alert-circle" class="empty-icon"></i-tabler>
      <p class="empty-title">Sin proveedores disponibles</p>
      <p class="empty-desc">
        {{
          providersCatalogMessage ||
            "No se encontraron proveedores vinculados a este servicio en Sourcing."
        }}
      </p>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoadingCatalog" class="loading-container">
      <div class="spinner-shell">
        <mat-spinner diameter="38" color="primary"></mat-spinner>
      </div>
      <p class="loading-label">Consultando catálogo de proveedores...</p>
      <span class="loading-sublabel">Por favor espere un momento</span>
    </div>
  </div>

  <div class="modal-actions">
    <button
      mat-stroked-button
      type="button"
      class="button-secondary"
      (click)="handleCancelClick()"
    >
      Cancelar
    </button>
    <button
      mat-flat-button
      type="button"
      class="button-primary"
      (click)="handleSaveChangeProvider()"
      [disabled]="
        isLoadingCatalog || isProvidersListEmpty || !providerSearchControl.value
      "
    >
      <i-tabler name="check"></i-tabler>
      <span>Guardar Cambio</span>
    </button>
  </div>
</div>
